<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="center-para1"><a id="page_vii"></a><em>Two gates the silent house of Sleep adorn:<br/>Of polished ivory this, that of transparent horn:<br/>True visions through transparent horn arise;<br/>Through polished ivory pass deluding lies</em>.</p>
<p class="para"> </p>
<p class="center-para">—John Dryden, <em>Aeneid</em>, 6.1235–38</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?a105feda